import { useState, useEffect } from 'react'
import countries from 'i18n-iso-countries'

import { DropdownWithoutOptions, Option } from '../Dropdown'

import Dropdown from '../Dropdown'

type Props = DropdownWithoutOptions & {
  className?: string
  handleChange: (fieldId: string, id: string) => void
  selectedLanguage?: string
  inputId: string
}

DropdownCountryCode.defaultProps = {
  className: '',
  selectedLanguage: 'en',
}

export const supportedTranslations: Set<string> = new Set([
  'ar',
  'az',
  'be',
  'bg',
  'bs',
  'ca',
  'cs',
  'da',
  'de',
  'en',
  'es',
  'et',
  'fa',
  'fi',
  'fr',
  'el',
  'he',
  'hr',
  'hu',
  'hy',
  'it',
  'id',
  'ja',
  'ka',
  'kk',
  'ko',
  'ky',
  'lt',
  'lv',
  'mk',
  'mn',
  'nb',
  'nl',
  'nn',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sl',
  'sr',
  'sv',
  'tr',
  'uk',
  'uz',
  'zh',
])

function DropdownCountryCode({
  className,
  errorText,
  label,
  selectedLanguage,
  inputId,
  isRequired,
  placeholder,
  handleChange,
  selectedOption,
  variant,
}: Props) {
  const [options, setOptions] = useState<Option[]>([])

  useEffect(() => {
    if (selectedLanguage) {
      const verifiedLanguage = supportedTranslations.has(selectedLanguage)
        ? selectedLanguage
        : 'en'
      const importSupportedLanguage = async (lang: string) => {
        const langFile = `${lang}.json`
        const importedLang = await import(
          `i18n-iso-countries/langs/${langFile}`
        )
        countries.registerLocale(importedLang)

        const generateOptions = Object.entries(
          countries.getNames(selectedLanguage),
        )
          .map(([value, label]) => ({ value, label }))
          .sort((a, b) => a.label.localeCompare(b.label))

        // Manually add 'Global' as an additional "Country"
        generateOptions.unshift({ value: 'ONLINE', label: 'Online - Global' })

        setOptions(generateOptions)
      }
      importSupportedLanguage(verifiedLanguage)
    }
  }, [selectedLanguage])

  return (
    <Dropdown
      className={className}
      errorText={errorText}
      handleOptionChange={(id) => handleChange(inputId, id)}
      inputId={inputId}
      isRequired={isRequired}
      label={label}
      options={options}
      placeholder={placeholder}
      selectedOption={selectedOption}
      variant={variant}
    />
  )
}

export default DropdownCountryCode
